/**
 * 返回文件 Hash 值
 * @param {File} file
 * @returns {Promise<number>}
 */
export function hashFile(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			const view = new Uint8ClampedArray(reader.result);

			const step = view.length <= 2048 ? 1 : view.length >> 10;

			let hash = 0;
			for (let i = 0, j = 0; i < view.length; i += step) {
				hash = hash ^ (view[i] << (j % 4))
				j++;
			}
			resolve(hash);
		};
		reader.readAsArrayBuffer(file);
	});
}



// WEBPACK FOOTER //
// ./lib/helpers/hashFile.js